'use strict';

customerZone

/**
 * A progress bar (wrapping around an html progress element)
 *
 * @param number ng-model: model value to bind to
 * @param max: maximum value for the progress
 */
.component('progressBar', {
    bindings: {
        max: '<',
        ngModel: '<'
    },
    templateUrl: customerZone.fromBase('components/progress-bar/progress-bar.component.html')
});
